// Paleta compartida por los graficos de este dashboard, para que un mismo
// establecimiento se identifique con el mismo color en todos los widgets.
export const COLORES_ESTABLECIMIENTO = ["#3b82f6", "#22c55e", "#8b5cf6", "#f97316", "#ef4444", "#06b6d4", "#eab308", "#64748b"];
export const NOMBRES_MES_CORTO = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Set", "Oct", "Nov", "Dic"];
